import { useState, Suspense } from "react";
import { Mail } from "lucide-react";
import { lazyWithRetry } from "@/lib/lazyWithRetry";
import { LoadingSpinner } from "@/components/LoadingSpinner";
const ContactFormDialog = lazyWithRetry(() => import("./ContactFormDialog").then(m => ({ default: m.ContactFormDialog })));

export const FloatingContactButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [mounted, setMounted] = useState(false);

  return (
    <>
      <button
        id="btn-contact-floating"
        onClick={() => { setMounted(true); setIsOpen(true); }}
        className="tour-contact-btn fixed bottom-24 right-6 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-cart text-cart-foreground shadow-lg transition-all hover:scale-110 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2"
        aria-label="Üzenet küldése"
      >
        <Mail className="h-6 w-6" />
      </button>
      
      {mounted && <Suspense fallback={isOpen ? <LoadingSpinner /> : null}><ContactFormDialog open={isOpen} onOpenChange={setIsOpen} /></Suspense>}
    </>
  );
};
